import {Component, OnInit, inject} from '@angular/core';
import {OfferService} from '../../data/services/offer.service';
import {TranslationService} from '../../core/services/translation.service';
import {ActivatedRoute, Router} from '@angular/router';
import {Offer} from '../../data/models/offer.model';
import {ImageService} from '../../core/services/image.service';
import {CssPropertiesEnum} from '../../core/models/css-properties.enum';
import {VHostService} from '../../core/services/v-host.service';
import {ConfigService} from '../../core/services/config.service';
import {NavigationCommand, NavigationService} from '../../data/services/navigation.service';
import {LandingPageService} from '../../data/services/landing-page.service';
import {LandingPage} from '../../data/models/landing-page.model';
import {ExternalOffer} from 'src/app/data/models/external-offer.model';
import {ExternalOfferService} from 'src/app/core/services/external-offer.service';
import {ImageHandler} from "../../core/services/image-handler.service";

import {CssPropertyPipe} from "../../core/pipes/css-property.pipe";
import {GeneralErrorsComponent} from "../../core/components/general-errors/general-errors.component";
import {LoadingSpinnerComponent} from "../../core/components/loading-spinner/loading-spinner.component";
import {OfferCardComponent} from "./offer-card/offer-card.component";
import {ExternalOfferCardComponent} from "./external-offer-card/external-offer-card.component";
import {MatButton} from "@angular/material/button";
import {ApplyIfNotEmptyDirective} from "../../core/directives/apply-if-not-empty.directive";
import {NgOptimizedImage} from '@angular/common';

@Component({
  selector: 'app-hup-offer',
  templateUrl: './offer.component.html',
  styleUrls: ['./offer.component.scss'],
  imports: [
    CssPropertyPipe,
    GeneralErrorsComponent,
    LoadingSpinnerComponent,
    OfferCardComponent,
    ExternalOfferCardComponent,
    MatButton,
    ApplyIfNotEmptyDirective,
    CssPropertyPipe,
    NgOptimizedImage,
  ],
  standalone: true
})
export class OfferComponent implements OnInit {
  private offerService = inject(OfferService);
  imageService = inject(ImageService);
  translationService = inject(TranslationService);
  private route = inject(ActivatedRoute);
  vHostService = inject(VHostService);
  configService = inject(ConfigService);
  private navigationService = inject(NavigationService);
  private landingPageService = inject(LandingPageService);
  private router = inject(Router);
  private externalOfferService = inject(ExternalOfferService);
  private imageHandler: ImageHandler = inject(ImageHandler);

  isLoadingOffer: boolean = false;
  offers: Offer[] = [];
  activeGroup = null;
  moreThanOneGroup: boolean = false;
  errorsArr: string[] = [];
  CssPropertiesEnum = CssPropertiesEnum;
  actualPage: LandingPage;
  externalOffers: ExternalOffer[] = [];
  cssPropertyPipe = new CssPropertyPipe();

  ngOnInit(): void {
    this.route.paramMap.subscribe(param => {
      this.activeGroup = param.get('offerGroup');
      this.moreThanOneGroup = param.get('moreThanOneGroup') === '1';
    });

    this.isLoadingOffer = true;
    this.offerService.getMinimalOffers(true).subscribe({
      next: offers => {
        this.isLoadingOffer = false;
        this.offers = offers;
      },
      error: () => {
        this.isLoadingOffer = false;
        this.errorsArr.push(this.translationService.getTranslation('error_offer_init'));
      }
    });

    this.landingPageService.getPageOfUrl(this.router.url.split('/')[1]).subscribe(page => {
      this.actualPage = page;
    });

    this.externalOfferService.loadExternalOffersForOfferGroup(this.activeGroup).subscribe({
      next: externalOffers => {
        if (externalOffers) {
          this.externalOffers = externalOffers;
          this.externalOffers.forEach(e => {
            this.imageService.getImageOfExternalOffer(e.id).subscribe(image => {
              if (image) {
                e.image = this.imageHandler.addAltText(image, e.header ?? this.translationService.getTranslation('externalOffer.image.altText.default'));
                if (!e.image) {
                  externalOffers.splice(externalOffers.indexOf(e));
                }
              }
            });
          });
        }
      },
      error: () => console.info('no external offer for group ' + this.activeGroup)
    })
  }

  goBackToGroupView(): void {
    this.navigationService.navigateTo(NavigationCommand.OFFER).then(() => null);
  }

  hasCustomResponsivClasses() {
    return !!this.getCustomResponsivClasses();
  }

  getCustomResponsivClasses() {
    const t = this.cssPropertyPipe.transform;

    const classes = [
      'col-' + t(CssPropertiesEnum.offerFxFlex, this.vHostService),
      'col-sm-' + t(CssPropertiesEnum.offerFxFlexSM, this.vHostService),
      'col-md-' + t(CssPropertiesEnum.offerFxFlexMD, this.vHostService),
      'col-lg-' + t(CssPropertiesEnum.offerFxFlexLG, this.vHostService),
      'col-xl-' + t(CssPropertiesEnum.offerFxFlexXL, this.vHostService),
      'col-xxl-' + t(CssPropertiesEnum.offerFxFlexXXL, this.vHostService)
    ].join(' ');

    return /\d/.test(classes) ? classes : '';
  }
}
